module.exports = __webpack_public_path__ + "static/assets/bd35d0b4c2c843e1f8d628977724e791.jpg";